import { useState, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useToken } from "./tokenContext";
import useApi from "./apiService";
import ProtectedRoute from "./protectedRoute";
import LoadingSkeleton from "../components/loading";

const filterCache = {};
const CACHE_TTL = 5 * 60 * 1000;

const AssetProtectedRoute = ({ children, ...protectedRouteProps }) => {
  const { assetSlug } = useParams();
  const { userData, loading: tokenLoading } = useToken();
  const { fetchData } = useApi();
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (tokenLoading) return;

    const filter = userData?.filter;
    if (!filter) {
      setAllowed(true);
      return;
    }

    const cacheKey = filter.id;
    const cached = filterCache[cacheKey];
    if (cached && Date.now() - cached.timestamp < CACHE_TTL) {
      setAllowed(cached.slugs.includes(assetSlug));
      return;
    }

    setAllowed(null);
    let cancelled = false;

    fetchData(`/assets/filters/${filter.id}`)
      .then((response) => {
        if (cancelled) return;
        const slugs = (response.data || []).map((a) => a.slug);
        filterCache[cacheKey] = { slugs, timestamp: Date.now() };
        setAllowed(slugs.includes(assetSlug));
      })
      .catch(() => {
        if (!cancelled) setAllowed(false);
      });

    return () => {
      cancelled = true;
    };
  }, [assetSlug, userData?.filter?.id, tokenLoading]);

  if (tokenLoading || allowed === null) return <LoadingSkeleton />;
  if (!allowed) return <Navigate to="/semPermissao" replace />;

  return <ProtectedRoute {...protectedRouteProps}>{children}</ProtectedRoute>;
};

AssetProtectedRoute.propTypes = {
  children: PropTypes.node,
};

export default AssetProtectedRoute;
